<template>
  <page-content>
    <panel title="Thông tin tìm kiếm">

      <c-form ref="searchForm">

        <b-row>
          <c-input v-model="packageOrdersStr"
                   form-group-class="col"
                   label="Package order"
                   placeholder='Danh sách đơn hàng (Ngăn cách bằng dấu ",")'
                   validate-rules="required"/>

        </b-row>

        <b-row>
          <b-col class="text-center">
            <button class="btn btn-success" type="button" @click="searchFf()">
              <i class="fas fa-search"></i> Xem thông tin đơn hàng
            </button>

            <button class="btn btn-warning" type="button" @click="$refs.searchForm.submit();showConfirm = !!packageOrdersStr">
              <i class="fas fa-shipping-timed"></i> Xử lý xuất đơn
            </button>

          </b-col>
        </b-row>
      </c-form>

    </panel>

    <panel :is-open.sync="showFF"
           show-close
           show-collapse
           title="Thông tin đơn hàng trên hệ thống FF"
           @close="fFData = []"
    >
      <b-table
          :fields="[
                  'package_order',
                  'bill_package_id',
                  'bill_package_status',
                  'bill_id',
                  'bill_type',
                  'bill_status',
                  {key:'action_btns', label: 'Thao tác', tdClass:'text-center'},
              ]"
          :items="fFData"
          :responsive="true"
          bordered
          hover
          small
      >

        <template #cell(action_btns)="row">
          <b-button
              class="btn btn-icon"
              title="Xem chi tiết"
              variant="success"
              @click="row.toggleDetails"
          >
            <i :class="{'fa-eye': !row.detailsShowing, 'fa-eye-slash': row.detailsShowing}" class="fas"></i>
          </b-button>
        </template>

        <template #row-details="row">
          <b-card>

            <b-table-simple bordered hover>
              <b-tr>
                <b-th class="text-sm-right" style="width: 30%">src_warehouse_id</b-th>
                <b-td>{{ row.item.src_warehouse_id }}</b-td>
              </b-tr>
              <b-tr>
                <b-th class="text-sm-right">src_warehouse_name</b-th>
                <b-td>{{ row.item.src_warehouse_name }}</b-td>
              </b-tr>
              <b-tr>
                <b-th class="text-sm-right">src_warehouse_ff</b-th>
                <b-td>{{ row.item.src_warehouse_ff }}</b-td>
              </b-tr>

              <b-tr>
                <b-th class="text-sm-right">dst_warehouse_id</b-th>
                <b-td>{{ row.item.dst_warehouse_id }}</b-td>
              </b-tr>
              <b-tr>
                <b-th class="text-sm-right">dst_warehouse_name</b-th>
                <b-td>{{ row.item.dst_warehouse_name }}</b-td>
              </b-tr>
              <b-tr>
                <b-th class="text-sm-right">dst_warehouse_ff</b-th>
                <b-td>{{ row.item.dst_warehouse_ff }}</b-td>
              </b-tr>
            </b-table-simple>

            <b-button size="sm" @click="row.toggleDetails"><i class="fas fa-eye-slash"></i> Ẩn chi tiết</b-button>
          </b-card>
        </template>
      </b-table>
    </panel>

    <jc-dialog ref="dialog" :show.sync="showConfirm"
               btn-confirm-text='<i class="fas fa-check-circle"></i> Xác nhận'
               title="Xác nhận xuất đơn"
               type="orange"
               @onConfirm="exportPackage()"
    >
      <p>
        Thao tác này sẽ chuyển trạng thái đơn sang <b>đã xuất</b> cho tất cả các package_order đã nhập
      </p>
      <h5>
        Xác nhận thực hiện xuất đơn hàng ?
      </h5>

    </jc-dialog>
  </page-content>
</template>

<script>
export default {
  name: "Index",
  data() {
    return {
      packageOrdersStr: '',
      fFData: [],
      showFF: false,
      showConfirm: false,
    }
  },
  computed: {
    packageOrders() {
      return this.packageOrdersStr ? this.packageOrdersStr.split(',').map(x => x.trim()) : [];
    }
  },
  methods: {
    searchFf() {
      this.$refs.searchForm
          .validate()
          .then(() => {
            this.$http.post(
                "/cms/api/v1.0/bill-package/get-bill-package-info",
                {
                  "package_orders": this.packageOrders
                })
                .then(res => {
                  this.fFData = res.data;
                  this.showFF = true;
                }).catch(error => {
              this.errorNotify(error);
            })
          })
    },
    exportPackage() {
      this.$refs.searchForm
          .validate()
          .then(() => {
            this.$adminService
                .post(`/v1.0/admin/packages/error`, {"packagesOrder": this.packageOrders})
                .then(res => {
                  this.$success();
                  this.showConfirm = false;
                  this.searchFf();
                })
                .catch(err => {
                  this.errorNotify(err);
                })
          });
    }
  }
}
</script>

<style scoped>

</style>